export default __webpack_public_path__ + "static/media/carolina-alves-title.7dc9c5f4.png";